import type { z } from 'zod';

import { ApiError } from './api-error';

export async function browserApiRequest<T>(
  path: `/api/${string}`,
  schema: z.ZodType<T>,
  init: RequestInit = {},
): Promise<T> {
  const headers = new Headers(init.headers);
  headers.set('Accept', 'application/json');
  if (init.body) headers.set('Content-Type', 'application/json');
  const response = await fetch(path, {
    ...init,
    credentials: 'same-origin',
    cache: 'no-store',
    headers,
  });
  const payload: unknown = await response.json().catch(() => null);
  if (!response.ok) {
    const error =
      payload && typeof payload === 'object' && 'error' in payload ? payload.error : null;
    const code =
      error && typeof error === 'object' && 'code' in error && typeof error.code === 'string'
        ? error.code
        : 'HTTP_ERROR';
    const message =
      error && typeof error === 'object' && 'message' in error && typeof error.message === 'string'
        ? error.message
        : 'Не удалось выполнить запрос.';
    const header = response.headers.get('Retry-After')?.trim() ?? '';
    const retryAfterSeconds = /^\d+$/.test(header) ? Number(header) : null;
    throw new ApiError(message, response.status, code, retryAfterSeconds);
  }
  const parsed = schema.safeParse(payload);
  if (!parsed.success) throw new ApiError('Некорректный ответ сервера.', 502, 'INVALID_RESPONSE');
  return parsed.data;
}
